// extracted by mini-css-extract-plugin
export var connectionButton = "_br-1";
export var rightPanel = "_br-3";
export var stepDescription = "_br-2";
export var stepIcon = "_br-0";